import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { Hostel } from '@app/services/api/api.service';

@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class RecommendationsComponent {
  @Input()
  public hostel: Hostel;
  public label = '';
  private destroyed = new Subject<void>();

  public top4Recommendations = [];
  constructor() {}

  ngOnInit() {
    if ((this.hostel.recommendationsFromBackpackers?.length ?? 0) > 4) {
      this.label = `+ ${
        this.hostel?.recommendationsFromBackpackers?.length - 4
      } more`;
    }
    this.top4Recommendations = this.hostel.recommendationsFromBackpackers.slice(
      0,
      4
    );
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
